/** One ALCOA+ verdict as a colour-coded chip. */

import { Badge } from "@mantine/core";
import { STATUS_COLOR, STATUS_LABEL, type QualityStatus } from "./types";

interface Props {
  status: QualityStatus;
  /** Short form for the matrix (e.g. "N/A"). */
  compact?: boolean;
}

export function QualityStatusChip({ status, compact = false }: Props) {
  const label = compact && status === "not_assessable" ? "N/A" : STATUS_LABEL[status];
  return (
    <Badge
      color={STATUS_COLOR[status]}
      variant={status === "fail" ? "filled" : "light"}
      size="sm"
      radius="sm"
      aria-label={STATUS_LABEL[status]}
      data-status={status}
    >
      {label}
    </Badge>
  );
}
